/*
 * actions.js
 */


 // constants
 export const RECEIVE_QUOTE = 'RECEIVE_QUOTE';
 export const REQUEST_OPEN = 'REQUEST_OPEN';
 export const REQUEST_COMPLETE = 'REQUEST_COMPLETE';

 export function receiveQuote(data){
    return {
        type: RECEIVE_QUOTE,
        data: data
    }
 }


// WEBPACK FOOTER //
// ./src/Action/action.js